/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

import {debounce} from 'lodash/function';
import swal from 'sweetalert';

const _ = require('lodash');

const MARKETS_BOX_ONE_VH_SETTING = 35;
const MARKETS_SCROLLER_PERC = 0.85;

const MARKETS_BOX_TWO_VH_SETTING = 22;
const MARKETS_OTHER_SCROLLER_PERC = 0.8;

const MARKETS_THREE_VH_SETTING = 17;
const MARKETS_BOX_FOUR_VH_SETTING = 13;

const PRODUCTS_BOX_ONE_VH_SETTING = 28; //hs6
const PRODUCTS_SCROLLER_PERC = 0.85;
const PRODUCTS_BOX_TWO_VH_SETTING = 16; // hs4
const PRODUCTS_OTHER_SCROLLER_PERC = 0.7;
const PRODUCTS_THREE_VH_SETTING = 16; //hs2
const PRODUCTS_BOX_FOUR_VH_SETTING = 16; // section

export default {
  data: function() {
    return {
      skip_cancel: true,

      markets_box_one_vh: MARKETS_BOX_ONE_VH_SETTING,
      markets_box_one_scroller_vh: Math.round(
        MARKETS_BOX_ONE_VH_SETTING * MARKETS_SCROLLER_PERC,
      ),

      markets_box_two_vh: MARKETS_BOX_TWO_VH_SETTING,
      markets_box_two_scroller_vh: Math.round(
        MARKETS_BOX_TWO_VH_SETTING * MARKETS_OTHER_SCROLLER_PERC,
      ),

      markets_box_three_vh: MARKETS_THREE_VH_SETTING,
      markets_box_three_scroller_vh: Math.round(
        MARKETS_THREE_VH_SETTING * MARKETS_OTHER_SCROLLER_PERC,
      ),

      markets_box_four_vh: MARKETS_BOX_FOUR_VH_SETTING,
      markets_box_four_scroller_vh: Math.round(MARKETS_BOX_FOUR_VH_SETTING * 0.6),

      //

      products_box_one_vh: PRODUCTS_BOX_ONE_VH_SETTING,
      products_box_one_scroller_vh: Math.round(
        PRODUCTS_BOX_ONE_VH_SETTING * PRODUCTS_SCROLLER_PERC,
      ),

      products_box_two_vh: PRODUCTS_BOX_TWO_VH_SETTING,
      products_box_two_scroller_vh: Math.round(
        PRODUCTS_BOX_TWO_VH_SETTING * PRODUCTS_OTHER_SCROLLER_PERC,
      ),

      products_box_three_vh: PRODUCTS_THREE_VH_SETTING,
      products_box_three_scroller_vh: Math.round(
        PRODUCTS_THREE_VH_SETTING * PRODUCTS_OTHER_SCROLLER_PERC,
      ),

      products_box_four_vh: PRODUCTS_BOX_FOUR_VH_SETTING,
      products_box_four_scroller_vh: Math.round(PRODUCTS_BOX_FOUR_VH_SETTING * 0.6),
    };
  },

  methods: {
    async loadlist(listType, key, listValues) {
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections[listType][
        key
      ] = [];

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections[listType][
        key
      ] = listValues;

      this.updating = true;
      this.skip_cancel = false;
      await this.search_box_update_filters_combos();
      this.updating = false;
    },

    box_click: async function(listType, key, item, update_combos) {
      // add the selected item to the current transaction
      // this should not happen if the object is selected
      // so test before the push below to ignore the below
      this.skip_cancel = false;
      // console.log(this.current_transaction);
      if (
        _.indexOf(
          //if the selected key is already in the list dont push to current transaction
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections[
            listType
          ][key],
          item[key],
        ) === -1
      ) {
        this.current_transaction[key].push(`${item[key]}`);
      } else {
        this.current_transaction[key] = _.without(
          this.current_transaction[key],
          item[key],
          // so it was selected but now unselected
          this.current_transaction[`${key}_Unselected`].push(item[key]),
        );
      }

      // Adds the clicked item (HS6,4,2,Section) code to the list of selected values
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections[listType][
        key
      ].push(`${item[key]}`); //if a duplicate is pushed it will be unselected.

      // Get updated combinations but not to fast
      // this.debounce_search_box_update_filters_combos();
      if (update_combos) {
        this.updating = true;
        this.loading_stack.push('1');
        await this.search_box_update_filters_combos();
        this.loading_stack.pop();
        this.updating = false;
      }
    },

    // debounces the click on product or market. dont call api to often
    debounce_search_box_update_filters_combos: _.debounce(function() {
      this.search_box_update_filters_combos();
    }, 500),

    async dummy_select_all() {
      const list_copy = this.general_box_filter(['HS6_Code']);
      for (let i = 0; i < list_copy.length; i++) {
        console.log(i);
        const item = list_copy[i];
        // select all if not selected and all selected clicked
        item['HS6_Code_Selected'] = true;
        this.current_transaction['HS6_Code'].push(`${item['HS6_Code']}`);
      }

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections['products'][
        'HS6_Code'
      ] = this.current_transaction['HS6_Code'];
    },

    async to_many_selections(hit_hs4_max, hit_hs6_max) {
      if (hit_hs4_max || hit_hs6_max) {
        let warning =
          'Your query still has to many resulting products – please use sub-selections of ' +
          `${hit_hs4_max ? 'HS4 ' : ''}` +
          `${hit_hs4_max & hit_hs6_max ? ' or ' : ''}` +
          `${hit_hs6_max ? 'HS6 ' : ''}` +
          `to reduce the number of products to a maximum of ${this.hs6_max}`;

        await swal(warning);
      }
    },

    async select_all_codes(key) {
      await this.general_box_filter([key]).forEach(item => {
        // select all if not selected and all selected clicked
        if (!item[`${key}_Selected`]) {
          this.box_click('products', key, item, false);
        }
      });
    },

    async select_all_products(key, limit) {
      if (limit >= this.general_box_filter([key]).length) {
        this.other_change_except_selection = true;

        if (key === 'HS6_Code') {
          if (this.hs6_max >= this.general_box_filter(['HS6_Code']).length) {
            await this.select_all_codes('HS6_Code');
          }
        }

        let hit_hs4_max = false;
        let hit_hs6_max = false;

        if (key === 'HS4_Code') {
          if (this.hs4_max >= this.general_box_filter(['HS4_Code']).length) {
            await this.select_all_codes('HS4_Code');
          }
          if (this.hs6_max >= this.general_box_filter(['HS6_Code']).length) {
            await this.select_all_codes('HS6_Code');
          } else {
            hit_hs6_max = true;
          }
        }

        if (key === 'HS2_Code') {
          if (this.hs2_max >= this.general_box_filter(['HS2_Code']).length) {
            await this.select_all_codes('HS2_Code');
          }
          if (this.hs4_max >= this.general_box_filter(['HS4_Code']).length) {
            await this.select_all_codes('HS4_Code');
          } else {
            hit_hs4_max = true;
          }
          if (this.hs6_max >= this.general_box_filter(['HS6_Code']).length) {
            await this.select_all_codes('HS6_Code');
          } else {
            hit_hs6_max = true;
          }
        }

        if (key === 'HS2_Groups') {
          if (this.hs2_section_max >= this.general_box_filter(['HS2_Groups']).length) {
            await this.select_all_codes('HS2_Groups');
          }
          if (this.hs2_max >= this.general_box_filter(['HS2_Code']).length) {
            await this.select_all_codes('HS2_Code');
          }
          if (this.hs4_max >= this.general_box_filter(['HS4_Code']).length) {
            await this.select_all_codes('HS4_Code');
          } else {
            hit_hs4_max = true;
          }
          if (this.hs6_max >= this.general_box_filter(['HS6_Code']).length) {
            await this.select_all_codes('HS6_Code');
          } else {
            hit_hs6_max = true;
          }
        }

        this.to_many_selections(hit_hs4_max, hit_hs6_max);
        // if (key === 'HS6_Code') {
        this.updating = true;
        await this.search_box_update_filters_combos();
        this.updating = false;
        this.clear_button_clicked_but_there_was_selections = true;

        // }
      } else {
        if (key === 'HS6_Code') {
          await this.to_many_selections(false, true);
        }
        if (key === 'HS4_Code') {
          await this.to_many_selections(true, false);
        }
      }
    },
    async unselect_all_products(key) {
      this.other_change_except_selection = true;
      await this.general_box_filter([key]).forEach(item => {
        // select all if not selected and all selected clicked
        if (item[`${key}_Selected`]) {
          // console.log(item[`${key}_Selected`]);
          this.box_click('products', key, item, false);
        }
      });
      if (key === 'HS6_Code') {
        this.updating = true;
        await this.search_box_update_filters_combos();
        this.updating = false;
        this.clear_button_clicked_but_there_was_selections = true;
      }
    },

    async select_all(listType, key, is_selected) {
      this.other_change_except_selection = true;
      // await this.loadlist('products', 'HS6_Code', ['HS420310']);
      this.general_box_filter([key]).forEach(item => {
        // select all if not selected and all selected clicked
        if (!item[`${key}_Selected`] && !is_selected) {
          this.box_click(listType, key, item, false);
        } else if (item[`${key}_Selected`] && is_selected) {
          this.box_click(listType, key, item, false);
        }
      });

      if (key === 'HS6_Code' || key === 'C_Code') {
        if (key === 'HS6_Code') {
          this.clear_button_clicked_but_there_was_selections = true;
        }
        this.all_selected_box_1 = !this.all_selected_box_1;
        // await this.search_box_update_filters_combos();
      }
      if (key === 'HS4_Code' || key === 'Sub_Region') {
        this.all_selected_box_2 = !this.all_selected_box_2;
      }
      if (key === 'HS2_Code' || key === 'Main_Region') {
        this.all_selected_box_3 = !this.all_selected_box_3;
      }
      if (key === 'HS2_Groups' || key === 'Trade_Group') {
        this.all_selected_box_4 = !this.all_selected_box_4;
      }
      // await this.search_box_update_filters_combos();
    },

    deselect_all() {
      console.log('to be implemented.');
    },
    async select_the_following_markets(itemList) {
      if (itemList.includes('Main_Region')) {
        if (!this.all_selected_box_3) {
          // this.last_clicked_box = 'Main_Region';
          this.select_all('markets', 'Main_Region', this.all_selected_box_3);

          if (!this.all_selected_box_2) {
            this.select_all('markets', 'Sub_Region', this.all_selected_box_2);
          }
          if (!this.all_selected_box_1) {
            this.select_all('markets', 'C_Code', this.all_selected_box_1);
          }
        } else {
          // this.last_clicked_box = null;
          if (this.all_selected_box_1) {
            this.select_all('markets', 'C_Code', this.all_selected_box_1);
          }
          if (this.all_selected_box_2) {
            this.select_all('markets', 'Sub_Region', this.all_selected_box_2);
          }
          this.select_all('markets', 'Main_Region', this.all_selected_box_3);
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Sub_Region = [];
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Main_Region = [];
          return;
        }
      }
      if (itemList.includes('Sub_Region')) {
        // alert('');
        // all is not selected
        if (!this.all_selected_box_2) {
          // this.last_clicked_box = 'Sub_Region';
          this.select_all('markets', 'Sub_Region', this.all_selected_box_2);
          if (!this.all_selected_box_1) {
            this.select_all('markets', 'C_Code', this.all_selected_box_1);
          }
          // all is selected
        } else {
          // this.last_clicked_box = null;
          // alert('here');
          if (this.all_selected_box_1) {
            this.select_all('markets', 'C_Code', this.all_selected_box_1);
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = [];
          }
          if (this.all_selected_box_3) {
            this.select_all('markets', 'Main_Region', this.all_selected_box_3);
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Main_Region = [];
          }
          this.select_all('markets', 'Sub_Region', this.all_selected_box_2);
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Sub_Region = [];
        }
      }

      if (itemList.includes('C_Code')) {
        // all is not selected
        if (!this.all_selected_box_1) {
          this.select_all('markets', 'C_Code', this.all_selected_box_1);

          if (this.all_selected_box_3) {
            this.select_all('markets', 'Main_Region', this.all_selected_box_3);
          }
          // all is selected
        } else {
          this.select_all('markets', 'C_Code', this.all_selected_box_1);
          if (this.all_selected_box_2) {
            this.select_all('markets', 'Sub_Region', this.all_selected_box_2);
          }
          if (this.all_selected_box_3) {
            this.select_all('markets', 'Main_Region', this.all_selected_box_3);
          }
        }
      }

      // let box_1 = this.all_selected_box_1;
      // let box_2 = this.all_selected_box_3;
      // let box_3 = this.all_selected_box_4;
      //
      // if (itemList.includes('C_Code')) {
      //   this.select_all('markets', 'C_Code', this.all_selected_box_1);
      //   if (box_2) {
      //     this.select_all('markets', 'Sub_Region', box_2);
      //   }
      // }
      //
      // if (itemList.includes('Sub_Region')) {
      //   this.select_all('markets', 'Sub_Region', this.all_selected_box_2);
      //   if (box_3) {
      //     this.select_all('markets', 'Main_Region', box_3);
      //   }
      // }
    },

    select_the_following_products() {
      this.select_all('products', 'HS2_Groups', this.all_selected_box_4);
      // this.select_all('products', 'HS2_Code', this.all_selected_box_4);
      // this.select_all('products', 'HS4_Code', this.all_selected_box_4);
    },
    search_box_update_filters_combos: async function() {
      // get dsm combinatons for the filters ,countries and products combinations

      const update_data = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;

      update_data.META.query_results.cube = [];
      update_data.META.query_results.cube_Main_Region = [];
      update_data.META.query_results.cube_C_Region = [];
      update_data.META.query_results.cube_Trade_Block = [];

      update_data.META.query_results.cube_HS6_Code = [];
      update_data.META.query_results.cube_HS4_Code = [];
      update_data.META.query_results.cube_HS2_Code = [];
      update_data.META.query_results.cube_Section = [];

      await this.axios
        .post(this.$store.getters.baseUrl + 'dsm_combinations_full/', update_data)
        .then(response => {
          // this.setCombinationsTradeValue(response.data);

          this.current_transaction.combinations = response.data;

          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations =
            response.data;

          this.filters_updating = false;
          this.$store.state.tradeDSM.updatingMainFilters = false;
          this.set_filter_box_selection_country([]);
          this.set_filter_box_selection_product([]);
        })
        .catch(e => {
          console.error(
            'Error in search_box_update_filters_combos, line 59, filterhelpers.js',
            e,
          );
          alert(e);
          this.filters_updating = false;
          this.$store.state.tradeDSM.updatingMainFilters = false;
        });

      return Promise.resolve(1);
    },
    filtered_text() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .filter_in_progress
        ? ' - Filtered'
        : '';
    },
    set_search_term_no_update(term) {
      this.tempDisableSearch = true;
      this.searchQuery = term;
    },
    clearProductCountrySearchLists(filterType) {
      if (filterType === 'countries') {
        this.$store.commit('set_list_manager_selection_country', []);
        this.$store.commit('set_filter_box_selection_country', []);
      }
      if (filterType === 'products') {
        this.$store.commit('set_list_manager_selection_product', []);
        this.$store.commit('set_filter_box_selection_product', []);
      }
    },
    //update selectors when clicking in filters
    updateSelectionListFromFilterBox(filterType) {
      let list_to_save = [];
      if (filterType === 'countries') {
        for (let i = 0; i < this.hs6FilterResults.length; i++) {
          let temp = this.hs6FilterResults[i];
          if (temp.selected) {
            list_to_save.push({
              name: temp.C_Name,
              code: temp.C_Code,
              included_in_search: true,
            });
          }
        }
        this.$store.commit('set_filter_box_selection_country', list_to_save);

        console.log(
          'Getting combinations from updateSelectionListFromFilterBox - Countries ...',
        );
        // this.get_combinations_trade_value(
        //   this.$store.getters.get_filter_box_selection_product,
        //   this.$store.getters.get_filter_box_selection_country,
        // );
      }
      if (filterType === 'products') {
        for (let i = 0; i < this.hs6FilterResults.length; i++) {
          let temp = this.hs6FilterResults[i];
          if (temp.selected) {
            list_to_save.push({
              name: temp.HS6_Description,
              code: temp.HS6_Code,
              included_in_search: true,
            });
          }
        }
        this.$store.commit('set_filter_box_selection_product', list_to_save);
      }
      //  --->this.get_combinations_trade_value(
      //   this.$store.getters.get_filter_box_selection_product,
      //   this.$store.getters.get_filter_box_selection_country,
      // );
      this.run_dsm_advanced_query();
    },

    //update the top selectors when the filters change.only for 1p1c
    syncFiltersToSelectors(filterType, filterResults) {
      // only if 1p1c is selected
      this.countHS6Selected();

      if (filterType === 'countries') {
        if (this.hs6Selected === 1) {
          this.$store.commit('setDSMFilterForSearch_Target_Market', filterResults);
          this.$store.commit('setDSMFilterForSearch_Target_MarketDict', filterResults);
        } else {
          this.$store.commit('setDSMFilterForSearch_Target_Market', '');
        }
      }
      if (filterType === 'products') {
        if (this.hs6Selected === 1) {
          this.$store.commit('setDSMFilterForSearch_Product', filterResults);
          this.$store.commit('setDSMFilterForSearch_ProductDict', filterResults);
        } else {
          this.$store.commit('setDSMFilterForSearch_Product', '');
        }
      }

      //this.$store.commit('setDSMFilterForSearch_Target_Market', '');
    },

    //
    // get_combinations_trade_value(product_list, country_list) {
    //   // if (!this.advanved_filter_in_progress) {
    //   console.log('Getting updated combinations ... ');
    //   let data = {
    //     home_market: this.$store.state.tradeDSM.dsm_filter_setttings.Home_Market,
    //     model_number: this.$store.state.app.selectedModelVersion,
    //     products: product_list.map(v => v.code),
    //     target_markets: country_list.map(v => v.code),
    //   };
    //
    //   // console.log('OK ganno get some combinations');
    //   this.$store.commit('setupdatingMarketProductCombinations', true);
    //   let resp_config = {
    //     headers: {
    //       Authorization: 'Bearer ' + localStorage.getItem('token'),
    //     },
    //   };
    //   this.axios
    //     .post(this.$store.getters.baseUrl + 'dsm_combinations', data, resp_config)
    //     .then(response => {
    //       // console.log(JSON.stringify(response.data));
    //       if (!this.advanved_filter_in_progress) {
    //         this.$store.commit('setCombinationsTradeValue', response.data.results);
    //       } else {
    //         this.$store.commit(
    //           'setCombinationsTradeValue',
    //           this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations,
    //         );
    //       }
    //
    //       this.$store.commit('setupdatingMarketProductCombinations', false);
    //     })
    //     .catch(e => {
    //       console.log(e);
    //       console.log(e);
    //       this.$store.commit('setupdatingMarketProductCombinations', false);
    //     });
    //   // }
    // },

    // update the 1p1c setting
    updateSelectorCombintations(filterType) {
      this.countHS6Selected();
      if (filterType === 'countries') {
        this.$store.commit('setDSM_Product_Combinations', {
          countries: this.hs6Selected,
        });
      }
      if (filterType === 'products') {
        this.$store.commit('setDSM_Product_Combinations', {
          products: this.hs6Selected,
        });
      }
      // console.log('||||||||| Updating combinations');
      // this.get_combinations_trade_value(
      //   this.$store.getters.get_list_manager_selection_product,
      //   this.$store.getters.get_list_manager_selection_country,
      // );
    },

    clearHS6SelectionsButton(filterType) {
      console.log(filterType);
      this.seths6Selections(false);
      this.hs6Selected = 0;

      this.set_search_term_no_update(' ');

      // this.countHS6Selected();
      // this.updateSelectorCombintations(filterType);
      // this.syncFiltersToSelectors(filterType);
    },

    countHS6Selected() {
      this.hs6Selected = 0;
      for (let p = 0; p < this.hs6FilterResults.length; p++) {
        if (this.hs6FilterResults[p].selected) {
          this.hs6Selected += 1;
        }
      }
    },

    highlight: function(dataString, query) {
      try {
        // console.log('highligher is running');
        return dataString.replace(
          new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'),
          match => {
            return '<span class="highlightText">' + match + '</span>';
          },
        );
      } catch (err) {
        return dataString;
      }
    },
    removeDuplicates: function(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    // This is where the debounce actually belongs.
    expensiveOperation: debounce(function() {
      this.isCalculating = true;
      setTimeout(
        function() {
          this.isCalculating = false;
          this.searchQueryIsDirty = false;
          // this.setResults();
        }.bind(this),
        200,
      );
    }, 500),
    sortArrayByKey(arrayToSort, keyToSortOn) {
      return arrayToSort
        .sort(function(a, b) {
          const keyToSortOnA = a[keyToSortOn];
          const keyToSortOnB = b[keyToSortOn];
          let comparison = 0;
          if (keyToSortOnA > keyToSortOnB) {
            comparison = 1;
          } else if (keyToSortOnA < keyToSortOnB) {
            comparison = -1;
          }
          return comparison;
        })
        .reverse();
    },
  },
  computed: {
    // return the outside filters results to the component if they change
    main_outside_results_changed() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results;
    },
    searchIndicator: function() {
      if (this.isCalculating) {
        return '⟳ Fetching new results';
      } else if (this.searchQueryIsDirty) {
        return 'Typing ...';
      } else {
        return 'Done searching. Click on items below to select. ✓ ';
      }
    },
  },
  watch: {
    // main_outside_results_changed(new_v) {
    //   this.current_transaction.combinations = new_v;
    // },
    searchQuery: function() {
      this.searchQueryIsDirty = true;
      this.expensiveOperation();
    },
  },
};
